var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAssistantPlayCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #6ad09d;\n      }\n\n      .st1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,20.8c5.5,0,10-4.5,10-10S16.3.8,10.8.8.8,5.2.8,10.8s4.5,10,10,10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,7.7c0-.5,0-.7,0-.8,0-.1.2-.2.4-.2.2,0,.4.1.8.4l4.7,3c.3.2.5.3.6.5,0,.1,0,.3,0,.4,0,.1-.2.3-.6.5l-4.7,3c-.4.3-.6.4-.8.4-.1,0-.3,0-.4-.2,0-.1,0-.4,0-.8v-6.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.8,20.8c5.5,0,10-4.5,10-10S16.3.8,10.8.8.8,5.2.8,10.8s4.5,10,10,10Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.2,7.7c0-.5,0-.7,0-.8,0-.1.2-.2.4-.2.2,0,.4.1.8.4l4.7,3c.3.2.5.3.6.5,0,.1,0,.3,0,.4,0,.1-.2.3-.6.5l-4.7,3c-.4.3-.6.4-.8.4-.1,0-.3,0-.4-.2,0-.1,0-.4,0-.8v-6.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantPlayCircle);
export default __webpack_public_path__ + "static/media/ai-assistant-play-circle.6a6a69b27748fbab75057fe1b93c890b.svg";
export { ForwardRef as ReactComponent };